import { useEffect, useState } from "react";
import { apiClient } from "src/api/apiService";
import { Contact } from "../Form/types";
import { usePermissions } from "src/hooks/usePermissions";

export const usePlumberName = (
  licensedPlumber: string | undefined,
  msaNumber: string | undefined
) => {
  const [plumberName, setPlumberName] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [licenseNumber, setLicenseNumber] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const { isHomeUser } = usePermissions();

  useEffect(() => {
    const fetchPlumbers = async () => {
      //directly return plumber name is it is home user as there are no ids to lookup
      if (isHomeUser) {
        setPlumberName(licensedPlumber || "");
        setFirstName("");
        setLastName("");
        setLicenseNumber("");
        setEmail("");
        setPhone("");
        return;
      }
      if (!msaNumber || !licensedPlumber) return;

      const { data } = await apiClient.get<Contact[]>(`/contact/${msaNumber}`, {
        params: { type: "PLUMBER" },
      });
      const plumber = data.find((c) => c.id === licensedPlumber);
      if (plumber) {
        const name = `${plumber.first_name} ${plumber.last_name}`;
        setPlumberName(name);
        setFirstName(plumber.first_name || "");
        setLastName(plumber.last_name || "");
        setLicenseNumber(plumber.license_number || "");
        setEmail(plumber.email || "");
        setPhone(plumber.phone_number || "");
      } else {
        setPlumberName("");
        setFirstName("");
        setLastName("");
        setLicenseNumber("");
        setEmail("");
        setPhone("");
      }
    };

    fetchPlumbers();
  }, [licensedPlumber, msaNumber, isHomeUser]);

  return {
    plumberName,
    firstName,
    lastName,
    licenseNumber,
    email,
    phone,
  };
};
